import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../store/store";
//import Modernizr from "modernizr";
// import { setPkg } from "../store/reducers/publicSlice";

import { MDXRenderer } from 'gatsby-plugin-mdx';
import { MDXProvider } from "@mdx-js/react";

// import PrivacyPopup from "../components/PrivacyPopup";
// import { Link, useStaticQuery, graphql } from 'gatsby';
import { Link, useStaticQuery, graphql } from 'gatsby';

import Bubbles from '../components/3dbubbles';

import MainMenu from "../components/MainMenu";

import { AnchorLink } from "gatsby-plugin-anchor-links";

type Props = {
    title: string;
    to: string,
};

type IContentPref = {
  className?: any;
  style?: any;
}

import SEO from '../components/SEO';

import Taglist from '../components/taglist';


const Case = ({page, id}:{page: any,id?: number}) => {

  const num = id ? id : 0;
  //const [scrollPosition, setScrollPosition] = useState(0);
  //const [screenHeight, setScreenHeight] = useState(typeof window !== 'undefined'? window.innerHeight : 0);
  const [imgOpacity, setOpacity] = useState(0);

  const handleScroll = () => {
    const position = window.pageYOffset;
    const height = window.innerHeight;
    //console.log(position);
    let opacity = Math.round(((height*num + height/2 - position) / height*2)*100)/100; //+ Math.round((screenHeight - position)*100)/100;
    //if (opacity < 0) opacity = 0;
    //console.log('opacity',opacity);

    // console.log('pos / screenH',position, screenHeight);
    // setScrollPosition(position);
    setOpacity(opacity);
  };

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleScroll);
    };
  }, []);
  //scale-0 
  //
  return (
    <article className="section case overflow-x-hidden w-full relative  overflow-y-visible h-60 sm:h-64 md:h-80 lg:h-96">
      <div className="justify-self-center self-center overflow-y-visible h-60 sm:h-64 md:h-80 lg:h-96 mb-6">
        {
          page.node.context.image ?
            <Link to={page.node.path+"/"}>
              <img className="h-60 w-60 sm:h-64 sm:w-64 md:w-80 md:h-80 lg:w-96 lg:h-96 transform object-cover rounded-full" style={{opacity: imgOpacity, transform: `scale(${2.5-imgOpacity})` }} src={page.node.context.image} />
            </Link>
          : ""
        }
      </div>
      <div className="text-content absolute bottom-0" style={{opacity: imgOpacity + 0.5}}>
        <h1 className="text-xl sm:text-2xl"><Link to={page.node.path+"/"}>{page.node.context.title}</Link></h1>
        <Taglist tags={page.node.context.keywords} url={page.node.path} />
        <p>{page.node.context.description}</p>
      </div>
    </article>

  );

}

const FolioImages = ({bgStyle, images}:{bgStyle: any, images: string[][]}) => {

  //const [imgOpacity, setOpacity] = useState(0);
  //const [sWidth, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);
  //const [sHeight, setHeight] = useState(typeof window !== 'undefined' ? window.innerHeight : 0);
 //position
  //const [imgOpacity, setOpacity] = useState(0);
  const [screen, setScreen] = useState(
    typeof window !== 'undefined' ?
    {
      width: window.innerWidth,
      height: window.innerHeight,
      y: window.pageYOffset,
    }: {
      width: 0,
      height: 0,
      y: 0,
    }
  )

  const handleScroll = () => {
    /*const position = window.pageYOffset;
    const height = window.innerHeight;
    const width = window.innerWidth;
    let opacity = 1 - Math.round(((height*0 + height/2 - position) / height*2)*100)/100; //+ Math.round((screenHeight - position)*100)/100;
    //let margin = Math.round( ((position) / height)*100 )/100 - 1 * width;
    //if (margin < 1) margin = 0;
    // console.log(margin);
    //let margin = opacity*width;
    //setOpacity(opacity);
    setWidth(window.innerHeight);*/
    setScreen({
      width: window.innerWidth,
      height: window.innerHeight,
      y: window.pageYOffset,
    })
  };

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleScroll);
    };
  }, []);
  //'grid grid-cols-'+images.length
  // <div /*className={'flex height-screen width-auto overflow-x-scroll'}*/></div>
  return (
    <div className="fixed z-0 w-screen h-screen" style={bgStyle}>
        {
          images?.map((image: any[], key: number) => {
            //let opacity = 1 - Math.round(((height*0 + height/2 - position) / height*2)*100)/100;
            //+ screen.height/2
            const keyValue /*opacity*/ = Math.round(
              ((screen.height*(key+1) - screen.y) / screen.height)*100
            )/100;
            //const iOpacity = (images.length-key+2)-imgOpacity;
            let iLeft = Math.round(keyValue*keyValue*2*screen.width);
            let opacity = 1;
            let blur = 0;
            if (keyValue < 0) {
              iLeft = 0;
              opacity = 1.25+keyValue;
              blur = Math.round(keyValue*keyValue*10); //20
              if (blur > 20) blur = 20;
            }
            // filter: `blur(${blur})`
            return (
              <div key={key} className={`absolute w-screen h-screen filter blur-${blur}`} style={{opacity: opacity, marginLeft: iLeft}}>
                {
                  image.map((img: any, subKey: number) => {
                    //console.log(img);
                    if (img.mdxType === "img") {
                      return <img className={`w-screen h-screen object-cover absolute`} src={img.src} key={subKey} alt={img.alt} />;
                    } else if (img.mdxType === "Video") {
                      //{/*autoPlay="true"*/}
                      const videoProps = {
                        className: "w-screen h-screen z-50 absolute",//object-fit w-screen h-screen
                        autoPlay: true,
                        loop: true,
                        muted: true,
                        id: img.id,
                        //controls: true,
                      }
                      //if (img.id) videoProps.id = img.id;
                      // 
                      //console.log('ref',img);
                      return (
                          <video {...videoProps} key={subKey} >
                              <source src={ img.src } type={ img.type } />
                              Sorry, your browser doesn't support embedded videos.
                          </video>
                      );
                    }
                    return "";
                  })
                }
              </div>
            );
          })
        }
    </div>
  );
}

const Template = ({location, data}: any) => {
  let dispatch: any = (action: any) => {};

  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [videoAutoplay, setVideoAutoplay]= useState<undefined | boolean>(undefined);

  const { mdx } = data;
  //const { location } = data;
  const { frontmatter, body, headings, tableOfContents  } = mdx;

  const slugs = require('github-slugger')();
  //useStaticQuery(
  const Pages = useStaticQuery(graphql`
    query {
      allSitePage(
        filter: {path: {regex: "/portfolio/", nin: "/portfolio"}}
        sort: {fields: context___years, order: DESC}
      ) {
        edges {
          node {
            path
            context {
              title
              slug
              description
              keywords
              years
              image
            }
          }
        }
      }
    }
  `);
  //const { nodes } = Pages;

  const portfolioPages = Pages.allSitePage.edges;
  const portFolioImages: string[][] = [];

  const ids: string[] = []; 

  if (typeof window !== 'undefined') {
    dispatch = useDispatch<AppDispatch>();
    if (location && location.hash) {
      /*if (location.hash === "#pkg1") {
        dispatch(setPkg(1));
      } else if (location.hash === "#pkg2") {
        dispatch(setPkg(2));
      } else if (location.hash === "#pkg3") {
        dispatch(setPkg(3));
      }*/
    }
  }

  function extractIdFromString(str: string) {
    let string = str.replace(/ +$/, '');
    let matched = string.match(/ {#([^]+?)}$/);
    if (matched) {
      let id = matched[1];
      if (!!id.length) {
        const nString = string.substring(0, matched.index);
        if (!ids.includes(id)) {
          ids.push(id);
          return {
            children: nString,
            id: id
          }
        }
        return {
          children: nString
        }
      }
    }
    return {children: str}
  }

  
  const MyH1 = props => {
    //let id = props.id ? slugs.slug(props.id, true) : slugs.slug(props.children.toString());
    //console.log('h1',props);

    return <h1 {...props} />
    /*return (<React.Fragment>
      <h1 {...props} />
      { frontmatter.keywords ?
        <Taglist tags={frontmatter.keywords} />
        : ""
      }
      { frontmatter.years ?
        <div className="year">{frontmatter.years.length === 2 ? frontmatter.years.join("–") : frontmatter.years.join(",")}</div>
        : ""
      }
    </React.Fragment>)*/
  };
  
  const MyH2 = props => {
    const childrenWithId = extractIdFromString(props.children.toString());
    if (childrenWithId.id) {
      props = {...props, id: childrenWithId.id, children: childrenWithId.children};
    } else {
      props = {...props, children: childrenWithId.children};
    }
    return <h2 {...props} />
  };

  function playVideo(id: string) {
    //console.log('id',id)
    const vid:any = document.getElementById(id);
    if (vid && vid.play) {
      vid.play();
    }
  }

  const VideoPlay = props => {
    /*if (typeof window !== 'undefined') {
      if (videoAutoplay === undefined) {
        
        setTimeout(function(){
          const video:any = document.getElementById(props.video);
          //console.log('video paused',video.paused);
          setVideoAutoplay(!video.paused)
        }, 1000);
      } else if (videoAutoplay === true) {
        return "";
      }
      return <button className="btn sm text-black border-black" onClick={() => {playVideo(props.video)}}>{props.title}</button>;
    }
    return "";*/

    return <button className="btn sm text-black border-black md:hidden" onClick={() => {playVideo(props.video)}}>{props.title}</button>;
  }

  const Tags = () => {
    //return <React.Fragment />;
    return <Taglist tags={frontmatter.keywords} url={frontmatter.slug+"/"} />;
  }


  

  const components = {
    wrapper: ({ children, ...props }) => {
      const childrenArray = React.Children.toArray(children);
      let sectionChildren: any[] = [];
      const sections: any[] = [];
      let sectionId: string | undefined = undefined;
      let images: any[] = [];
      childrenArray.map((child) => {
        if ( child.props.mdxType === "h1" || child.props.mdxType === "h2" ) {
          if (sectionChildren.length > 0) {
            sections.push({
              id: sectionId,
              children: sectionChildren,
              //images: images,
            });
            if (images.length > 0) portFolioImages.push(images);
            sectionChildren = [];
            images = [];
          }
          const childrenWithId = extractIdFromString(child.props.children.toString());
          if (childrenWithId.id) {
            sectionId = childrenWithId.id;
          }
        } else {
          
        }
        //console.log('type',child.props.mdxType);
        if ( child.props.mdxType === "p" && 
              typeof child.props.children !== "string" && 
              child.props.children.props.mdxType === "img"
        ) { //SectionImages
          images.push(child.props.children.props);
        } else if ( child.props.mdxType === "Video" ) {
          images.push(child.props);
        } else {
          sectionChildren.push(child);
        }
        
      })
      if (sectionChildren.length > 0) {
        sections.push({
          id: sectionId,
          children: sectionChildren
        });
        if (images.length > 0) portFolioImages.push(images);
      }
      if (sections && sectionChildren.length > 0) {
        return (
          <React.Fragment>
            <FolioImages images={portFolioImages} bgStyle={bgStyle} />
            <article className="article z-20">
              {
                sections.map((section: any, key:number) => {
                  if (key === 0) {
                    let style = {};
                    if ( frontmatter.colors && frontmatter.colors.text ) {
                      style = {
                        color: frontmatter.colors.text,
                        backgroundColor: frontmatter.colors.bg,
                      }
                    }
                    let imageClass = "object-cover w-screen h-screen";
                    let textClass = "text-content z-10";
                    if (typeof window !== 'undefined') {
                      imageClass += " image-fade-in";
                      textClass += " header-text-fade-in";
                    }

                    return (
                      <header key={key} className="header relative" style={style} id={section.id}>
                        { frontmatter.slug !== "/portfolio" && frontmatter.image ?
                          <div className="absolute z-0">
                            <img className={imageClass} src={frontmatter.image} />
                          </div>
                          : ""
                        }
                        <div className={textClass}>
                          {
                            section.children.map((sec:any, sKey: number) => {
                              return sec;
                            })
                          }
                        </div>
                      </header>
                    );
                  }
                  return (
                    <section key={key} className="section relative pb-8" id={section.id}>
                      {/*<div className="">
                        {
                          section.images?.map((image: string, key: number) => (
                            <img src={image} key={key} />
                          ))
                        }
                      </div>*/}
                      <div className="text-content">{
                      section.children.map((sec:any, sKey: number) => sec)
                      }</div>
                    </section>
                  );
                })
              }
              {
                frontmatter.slug === "/portfolio"
                  ? ''
                  : <aside className="p-12 font-light text-white relative" style={bgStyle}><Link to="/portfolio">&lt; Back to the portfolio main page</Link></aside>
              }
            </article>
          </React.Fragment>
        );
      }
      return "";
    },
    Tags: Tags,
    VideoPlay: VideoPlay,
    h1: MyH1,
    h2: MyH2,
  }


  let contentPrefs:IContentPref = {
    className: "main-content portfolio-page relative z-20",
    /*style: {
      backgroundColor: "#019BC1"
    }*/
  }

  /*if ( frontmatter.colors && frontmatter.colors.bg ) {
    contentPrefs.style = {
      backgroundColor: frontmatter.colors.bg
    }
  }*/
  
  let bgStyle = {}

  if (frontmatter.colors?.bg) bgStyle = { backgroundColor: frontmatter.colors.bg};

  let content = (
    <React.Fragment>
      <main {...contentPrefs}>
        <MDXProvider components={components}>
            <MDXRenderer headings={headings}>{body}</MDXRenderer>
        </MDXProvider>
      </main>
    </React.Fragment>
  );

  if ( frontmatter.slug === "/portfolio" ) {
    contentPrefs.className = "main-content relative z-20";

    let imageClass = "object-cover w-screen h-screen";
    //let textClass = "text-content z-10";
    if (typeof window !== 'undefined') {
      imageClass += " image-fade-in";
      //textClass += " header-text-fade-in";
    }
    // px-12
    content = 
    <React.Fragment>
      <div className="fixed z-0 main-content">
        {/*<img className={imageClass} src="/img/kuumailmapallo.jpg" />*/}
        <Bubbles />
      </div>
      <main className="relative z-20 grid">    
        <MDXProvider components={components}>
          <MDXRenderer headings={headings}>{body}</MDXRenderer>
          {
            portfolioPages.map((page: any, key: number) => (
              <Case page={page} id={key} />
            ))
          }
        </MDXProvider>
      </main>
    </React.Fragment>;
  }

  let menuClass = "hidden";
  if (menuOpen === true) {
    menuClass = "h-screen";
  }

  let menuCenter = [];
  let menuRight = [
    <a href="/jussi-vanto">About</a>
  ];


  if ( frontmatter.lang && frontmatter.lang === "en" ) {
    menuCenter = [];
    menuRight = [];
  }

  useEffect(() => {
    
  }, []);

  return (
    <React.Fragment>
      <SEO page={frontmatter} />
      <header className="page-header z-90">
        <div className="md:hidden absolute text-3xl cursor-pointer text-normal" onClick={() => setMenuOpen(!menuOpen)}>
            { menuOpen === true ? "x" : "=" }
        </div>
        <nav className="nav">
          <div className="flex-auto md:flex-initial text-center py-2">
            <div className="inline-block font-serif">
              <Link to={'/'} title="Lemonade Farm" className="mr-2 inline-block"> 
                <img src="/img/lemonade-farm-icon.svg" className="w-5 -mb-1" alt="Lemonade Farm" />
                {/*<img alt="LeadTrigger" className="logo" style={{width: 140, height: "auto"}} src="/img/leadtrigger.svg" />
                <img alt="LeadTrigger" className="logo" style={{width: 120, height: "auto"}} src="/img/lead-trigger.svg" />*/}
              </Link>
              
              <Link to={'/portfolio'} title="Portfolio of Jussi Vanto">
                Personal portfolio
              </Link>
              {
                frontmatter.slug === "/portfolio"
                ? <span className="font-sans"> of Jussi Vanto</span>
                : <span className="font-sans">: {frontmatter.title}</span>
              }
            </div>
          </div>
          <div className="wide-nav pt-2">
            {menuCenter.map((item, key: number) => <React.Fragment key={key}>{item}</React.Fragment>)}
          </div>
          <div className="hidden md:block text-right pt-2" /* md:w-24 */>
            {menuRight.map((item, key: number) => <React.Fragment key={key}>{item}</React.Fragment>)}
          </div>
        </nav>
        <MainMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      </header>
      {content}
      {/*<footer className="page-footer flex w-full bg-primary-100 mt-20 bg-opacity-50">
        
        </footer>*/}
    </React.Fragment>
  );
}

export default Template;
